import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jinyong",
  "use": "icon-jinyong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jinyong\"><path d=\"M512 0C226.742857 0 0 226.742857 0 512s226.742857 512 512 512 512-226.742857 512-512-226.742857-512-512-512z m256 768c-29.257143 29.257143-73.142857 29.257143-102.4 0L248.685714 358.4c-29.257143-29.257143-29.257143-73.142857 0-102.4 29.257143-29.257143 73.142857-29.257143 102.4 0l416.914286 416.914286c29.257143 21.942857 29.257143 65.828571 0 95.085714z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol